import React from 'react';
import moment from 'moment';

// Las fechas HANA pueden ser valores nativos o cadenas; muestra una fecha estable en ambos casos.
const formatDate = (value) => {
    const m = moment(value);
    return m.isValid() ? m.format('DD-MM-YYYY') : (value || '--');
};

// Las sesiones MVENTAS pertenecen a Gas; cualquier otro origen se etiqueta Comercio.
const FormatOrigin = (typeUser) => {
    return typeUser === 'MVENTAS' ? 'Gas' : 'Comercio';
};

// Los formateadores se eligen por clave de encabezado y simplifican el ciclo genérico de celdas.
const formatters = {
    origin: (value, row) => FormatOrigin(row?.typeUser),
    docDate: (value) => formatDate(value),
    sessionStatus: (value) => String(value).toUpperCase() === 'O'
        ? <span className="badge badge-warning">Abierto</span>
        : <span className="badge badge-success">Cerrado</span>,
};

const renderHeader = (headers, selection, data) => (
    <tr>
        <th
            style={{ textAlign: 'center', whiteSpace: 'nowrap' }}
        >
            <input
                type="checkbox"
                style={{ minWidth: '100%' }}
                id="pending-cuts-select-all"
                checked={!!data?.length && data.every((row) => selection.selectedIds.includes(Number(row.idSession)))}
                onChange={(event) => selection.selectAll(event.target.checked)}
            />
        </th>
        {headers?.filter(h => h.active)?.map((h, index) => (
            <th
                key={index}
                style={{ textAlign: 'center', whiteSpace: 'nowrap' }}
            >
                {h.title}
            </th>
        ))}

        <th
            className="sticky-columns"
            style={{ backgroundColor: "#e9ecef", textAlign: 'center', whiteSpace: 'nowrap' }}
        >
            Acciones
        </th>
    </tr>
);

// Renderiza cortes del servidor y delega la acción de detalle a PendingCutsView.
const renderTableBody = (headers, data, selection, openDetails) => {
    const activeHeaders = (headers || []).filter(h => h.active);

    // DataTables controla el estado vacío en esta implementación heredada de tabla.
    if (!data?.length) {
        return null;
    }

    return data.map((row) => (
        <tr key={row.idSession}>
            <td
                style={{ textAlign: 'center', verticalAlign: 'middle', whiteSpace: 'nowrap' }}
            >
                <input
                    type="checkbox"
                    style={{ minWidth: '100%' }}
                    id={`pending-cut-${row.idSession}`}
                    checked={selection.selectedIds.includes(Number(row.idSession))}
                    onChange={() => selection.selectOne(row.idSession)}
                />
            </td>
            {activeHeaders?.map((h, i) => {
                let value = row[h.key];

                if (formatters[h.key]) {
                    value = formatters[h.key](row[h.key], row);
                }

                return (
                    <td
                        key={i}
                        style={{
                            textAlign: 'center',
                            verticalAlign: 'middle',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {value ?? ''}
                    </td>
                );
            })}

            <td
                className="sticky-columns"
                style={{
                    backgroundColor: "#e9ecef",
                    textAlign: 'center',
                    whiteSpace: 'nowrap'
                }}
            >
                {/* Esta es intencionalmente la única acción por fila de un reporte de solo lectura. */}
                <button
                    type="button"
                    className="btn btn-timbra-one btn-sm botonCorrect"
                    onClick={() => openDetails(row)}
                    style={{ fontWeight: '500' }}
                >
                    <i className="far fa-file-alt"></i> Ver Detalles
                </button>
            </td>
        </tr>
    ));
};

// Conserva el id porque el componente común DataTables lo utiliza.
const renderTable = (headers, data, selection, openDetails) => {
    return (
        <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
            <thead className="table-header">
                {renderHeader(headers, selection, data)}
            </thead>
            <tbody>
                {renderTableBody(headers, data, selection, openDetails)}
            </tbody>
        </table>
    );
};

// Punto de entrada elegido por DataTables cuando view === 'pendingCuts'.
export const renderPendingCuts = (headers, data, selection, openDetails) => {
    return renderTable(headers, data, selection, openDetails);
};
